  export default new Proxy({}, {
    get(_, key) {
      throw new Error(`Module "http" has been externalized for browser compatibility. Cannot access "http.${key}" in client code.  See https://vite.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
    }
  })